import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-mining',
  templateUrl: './data-mining.component.html',
  styleUrls: ['./data-mining.component.sass']
})
export class DataMiningComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
